(() => {
  if (window.HorizonHeroSlider) return;

  const SWIPE_THRESHOLD = 40;

  class HorizonHeroSlider {
    constructor(root) {
      this.root = root;
      this.index = 0;
      this.timer = null;
      this.slides = [...root.querySelectorAll('[data-hero-slide]')];
      this.dots = [...root.querySelectorAll('[data-hero-dot]')];
      this.prev = root.querySelector('[data-hero-prev]');
      this.next = root.querySelector('[data-hero-next]');

      if (!this.slides.length) return;

      const active = this.slides.findIndex((s) => s.classList.contains('is-active'));
      this.index = active > -1 ? active : 0;

      this.autoplayEnabled = root.dataset.autoplay === 'true';
      this.autoplaySpeed = Number(root.dataset.autoplaySpeed) || 6000;

      this.prev?.addEventListener('click', () => this.goTo(this.index - 1));
      this.next?.addEventListener('click', () => this.goTo(this.index + 1));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.goTo(Number(dot.dataset.heroDot)));
      });

      // Pausa solo con mouse real (en touch, mouseenter queda pegado y detenía el autoplay)
      root.addEventListener('pointerenter', (e) => {
        if (e.pointerType === 'mouse') this.pause();
      });
      root.addEventListener('pointerleave', (e) => {
        if (e.pointerType === 'mouse') this.play();
      });

      // Pausa con navegación por teclado
      root.addEventListener('focusin', (e) => {
        if (e.target.matches && e.target.matches(':focus-visible')) this.pause();
      });
      root.addEventListener('focusout', () => this.play());

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.pause();
        else this.play();
      });

      this.bindSwipe();
      this.goTo(this.index, false);
      this.play();
    }

    bindSwipe() {
      const area = this.root.querySelector('.horizon-hero__viewport') || this.root;
      area.style.touchAction = 'pan-y';

      let startX = 0;
      let startY = 0;
      let tracking = false;
      let swiped = false;

      area.addEventListener('dragstart', (e) => e.preventDefault());

      area.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        tracking = true;
        swiped = false;
        startX = e.clientX;
        startY = e.clientY;
      });

      area.addEventListener('pointerup', (e) => {
        if (!tracking) return;
        tracking = false;
        const dx = e.clientX - startX;
        const dy = e.clientY - startY;
        if (Math.abs(dx) > SWIPE_THRESHOLD && Math.abs(dx) > Math.abs(dy)) {
          swiped = true;
          this.goTo(dx < 0 ? this.index + 1 : this.index - 1);
        }
      });

      area.addEventListener('pointercancel', () => {
        tracking = false;
      });

      // Evita que un swipe abra el link del botón por accidente
      area.addEventListener(
        'click',
        (e) => {
          if (swiped) {
            e.preventDefault();
            e.stopPropagation();
            swiped = false;
          }
        },
        true
      );
    }

    goTo(index, restart = true) {
      const total = this.slides.length;
      this.index = ((index % total) + total) % total;

      this.slides.forEach((slide, i) => {
        const active = i === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      this.dots.forEach((dot, i) => {
        const active = i === this.index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });

      if (restart) this.play();
    }

    play() {
      this.pause();
      if (!this.autoplayEnabled || this.slides.length < 2 || this.locked) return;
      this.timer = window.setInterval(() => {
        this.goTo(this.index + 1, false);
      }, this.autoplaySpeed);
    }

    pause() {
      if (this.timer) {
        window.clearInterval(this.timer);
        this.timer = null;
      }
    }

    destroy() {
      this.pause();
      this.autoplayEnabled = false;
    }
  }

  window.HorizonHeroSlider = HorizonHeroSlider;
  const instances = new WeakMap();

  const init = (scope = document) => {
    scope.querySelectorAll('.horizon-hero[data-section-id]').forEach((root) => {
      if (instances.has(root)) return;
      instances.set(root, new HorizonHeroSlider(root));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }

  // Soporte para el editor de temas de Shopify
  document.addEventListener('shopify:section:load', (e) => init(e.target));

  document.addEventListener('shopify:section:unload', (e) => {
    e.target.querySelectorAll('.horizon-hero[data-section-id]').forEach((root) => {
      instances.get(root)?.destroy();
      instances.delete(root);
    });
  });

  document.addEventListener('shopify:block:select', (e) => {
    const slide = e.target.closest('[data-hero-slide]');
    const root = slide?.closest('.horizon-hero[data-section-id]');
    const slider = root && instances.get(root);
    if (!slider) return;
    slider.locked = true;
    slider.goTo(Number(slide.dataset.index), false);
    slider.pause();
  });

  document.addEventListener('shopify:block:deselect', (e) => {
    const root = e.target.closest('.horizon-hero[data-section-id]');
    const slider = root && instances.get(root);
    if (!slider) return;
    slider.locked = false;
    slider.play();
  });
})();
